module.exports = __webpack_public_path__ + "static/img/tianfangyuansucai4.eb0429b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tianfangyuansucai4.png
// module id = whUH
// module chunks = 52